/* ──────────────────────────────
   store/country/action.js
   ────────────────────────────── */

import axios from "axios";
import { Toast } from "../../util/Toast";
import {
  GET_COUNTRIES,
  UPDATE_COUNTRY_STATUS,
} from "./types";

/* ─────────────────────────────────────────────────────────────
   1. GET — all countries (admin)
   ─────────────────────────────────────────────────────────── */
export const getCountries = () => async (dispatch) => {
  try {
    const { data } = await axios.get("country/countries");

    if (data.countries) {
      const sorted = data.countries.sort(
        (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
      );

      dispatch({
        type: GET_COUNTRIES,
        payload: {
          countries: sorted,
          total: sorted.length,
        },
      });
    } else {
      Toast("error", "Failed to fetch countries");
    }
  } catch (err) {
    Toast("error", err.message);
  }
};

/* ─────────────────────────────────────────────────────────────
   2. PATCH — toggle country active/inactive
   ─────────────────────────────────────────────────────────── */
export const toggleCountryStatus = (countryId, isActive) => (dispatch) => {
  axios
    .put("country/country/status", { countryId, isActive })
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: UPDATE_COUNTRY_STATUS,
          payload: res.data.country,
        });
        Toast("success", "Country status updated!");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((err) => Toast("error", err.message));
};
